import { Breadcrumbs } from '@liveauctioneers/hammer-ui-core/breadcrumbs';
import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getSEOSearchPageBreadcrumbs } from '@/redux/modules/searchPromoted.selectors';

type Props = {
    /**
     * Static trail (collection pages). Wins over the breadcrumbs the search API returns, which
     * arrive on the *promoted* search response and therefore vanish when sort !== MostRelevant.
     */
    breadcrumbs?: { href: string; label: string }[];
    className?: string;
};

export const SearchResultsBreadcrumbs = ({ breadcrumbs, className }: Props) => {
    const navigate = useNavigate();
    const apiBreadcrumbs = useAppSelector(getSEOSearchPageBreadcrumbs);

    const onClick = useCallback(
        (href: string) => {
            navigate(href);
        },
        [navigate]
    );

    const breadcrumbsFormatted = useMemo(
        () =>
            breadcrumbs ??
            apiBreadcrumbs.map((breadcrumb) => ({
                href: breadcrumb.url,
                label: breadcrumb.name,
            })),
        [breadcrumbs, apiBreadcrumbs]
    );

    if (breadcrumbsFormatted.length === 0) {
        return null;
    }

    return (
        <Breadcrumbs
            aria-label="Search Results Breadcrumbs"
            breadcrumbs={[{ href: '/', label: 'Home' }, ...breadcrumbsFormatted]}
            className={className}
            onClick={onClick}
        />
    );
};
